import Header from '../components/header'
import Footer from '../components/footer'
import Eachpart from "../components/eachpart";
import './services.css'
// [Script] => Import all imgs from assets From importingScript file
import { images } from '../components/importingScript';


const Services = () => {
  return (
    <>
      <Header />
      <Eachpart pageName="Services" />
      {/* services */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: '500px', visibility: 'visible', animationDelay: '0.1s', animationName: 'fadeInUp'}}>
            <p className="fs-5 fw-medium text-primary">Our Services</p>
            <h1 className="display-5 mb-5">Digital Marketing Services that We Offer</h1>
          </div>
          <div className="row g-4">
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s" style={{visibility: 'visible', animationDelay: '0.1s', animationName: 'fadeInUp'}}>
              <div className="service-item position-relative h-100">
                <div className="service-text rounded p-5">
                  <div className="btn-square bg-light rounded-circle mx-auto mb-4" style={{width: '64px', height: '64px'}}>
                    <img className="img-fluid" src={images['./icon/icon-5.png']} alt="Icon" />
                  </div>
                  <h5 className="mb-3">Digital Marketing</h5>
                  <p className="mb-0">We develop customized digital marketing strategies that align with your business objectives, ensuring long-term success in the digital world.</p>
                </div>
                <div className="service-btn rounded-0 rounded-bottom">
                  <a className="text-primary fw-medium cur pointer" href>Read More<i className="bi bi-chevron-double-right ms-2" /></a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s" style={{visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp'}}>
              <div className="service-item position-relative h-100">
                <div className="service-text rounded p-5">
                  <div className="btn-square bg-light rounded-circle mx-auto mb-4" style={{width: '64px', height: '64px'}}>
                    <img className="img-fluid" src={images['./icon/icon-6.png']} alt="Icon" />
                  </div>
                  <h5 className="mb-3">Pay-Per-Click (PPC) Advertising</h5>
                  <p className="mb-0">Our expert team manages PPC campaigns on Google Ads and social media to drive targeted traffic and increase conversions while maximizing ROI.</p>
                </div>
                <div className="service-btn rounded-0 rounded-bottom">
                  <a className="text-primary fw-medium cur pointer" href>Read More<i className="bi bi-chevron-double-right ms-2" /></a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s" style={{visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp'}}>
              <div className="service-item position-relative h-100">
                <div className="service-text rounded p-5">
                  <div className="btn-square bg-light rounded-circle mx-auto mb-4" style={{width: '64px', height: '64px'}}>
                    <img className="img-fluid" src={images['./icon/icon-7.png']} alt="Icon" />
                  </div>
                  <h5 className="mb-3">Website Design & Development</h5>
                  <p className="mb-0">We design and develop responsive, user-friendly websites that are optimized for performance, speed, and a seamless user experience.</p>
                </div>
                <div className="service-btn rounded-0 rounded-bottom">
                  <a className="text-primary fw-medium cur pointer" href>Read More<i className="bi bi-chevron-double-right ms-2" /></a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s" style={{visibility: 'visible', animationDelay: '0.1s', animationName: 'fadeInUp'}}>
              <div className="service-item position-relative h-100">
                <div className="service-text rounded p-5">
                  <div className="btn-square bg-light rounded-circle mx-auto mb-4" style={{width: '64px', height: '64px'}}>
                    <img className="img-fluid" src={images['./icon/icon-8.png']} alt="Icon" />
                  </div>
                  <h5 className="mb-3">Social Media Marketing</h5>
                  <p className="mb-0">We create and manage engaging social media campaigns across platforms like Facebook, Instagram, LinkedIn, and Twitter to build brand awareness and foster customer loyalty.</p>
                </div>
                <div className="service-btn rounded-0 rounded-bottom">
                  <a className="text-primary fw-medium cur pointer" href>Read More<i className="bi bi-chevron-double-right ms-2" /></a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s" style={{visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp'}}>
              <div className="service-item position-relative h-100">
                <div className="service-text rounded p-5">
                  <div className="btn-square bg-light rounded-circle mx-auto mb-4" style={{width: '64px', height: '64px'}}>
                    <img className="img-fluid" src={images['./icon/icon-9.png']} alt="Icon" />
                  </div>
                  <h5 className="mb-3">Search Engine Optimisation</h5>
                  <p className="mb-0">Our SEO services boost your website’s visibility and organic search rankings through on-page optimization, technical SEO, content strategy, and link-building.</p>
                </div>
                <div className="service-btn rounded-0 rounded-bottom">
                  <a className="text-primary fw-medium cur pointer" href>Read More<i className="bi bi-chevron-double-right ms-2" /></a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s" style={{visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp'}}>
              <div className="service-item position-relative h-100">
                <div className="service-text rounded p-5">
                  <div className="btn-square bg-light rounded-circle mx-auto mb-4" style={{width: '64px', height: '64px'}}>
                    <img className="img-fluid" src={images['./icon/icon-10.png']} alt="Icon" />
                  </div>
                  <h5 className="mb-3">Branding & Graphic Design</h5>
                  <p className="mb-0">Our creative team helps establish a strong brand identity through logo design, visual assets, and messaging that resonate with your target audience.</p>
                </div>
                <div className="service-btn rounded-0 rounded-bottom">
                  <a className="text-primary fw-medium cur pointer" href>Read More<i className="bi bi-chevron-double-right ms-2" /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* services */}
      <Footer />
    </>
  );
}

export default Services;
